/**
 * Price Summary Component
 *
 * @package
 */

import { __ } from '@wordpress/i18n';
import { decodeHtmlEntities } from '../helpers/decodeHtmlEntities';
import { formatPrice } from '../helpers/priceHelpers';
import { useTotalCost } from '../helpers/useTotalCost';

const PriceSummary = ( {
	selectedBaseModel,
	selectedProducts,
	vatMode,
	workshopHourlyRate = 0,
	taxRate = 0,
	quantities = {},
} ) => {
	const {
		total,
		baseModelPrice,
		productsPrice,
		installationHours,
		baseModelName: rawBaseModelName,
	} = useTotalCost( selectedBaseModel, selectedProducts, vatMode, {
		workshopHourlyRate,
		taxRate,
		quantities,
	} );
	const baseModelName = decodeHtmlEntities( rawBaseModelName );

	return (
		<div className="configurator-price-summary" role="region" aria-label={ __( 'Price summary', 'at-vehicle-configurator' ) }>
			{ baseModelName && (
				<div className="configurator-price-item">
					<span className="configurator-price-label">{ baseModelName }</span>
					<span className="configurator-price-value">{ formatPrice( baseModelPrice ) }</span>
				</div>
			) }
			{ productsPrice > 0 && (
				<div className="configurator-price-item">
					<span className="configurator-price-label">{ __( 'Options Total', 'at-vehicle-configurator' ) }</span>
					<span className="configurator-price-value">{ formatPrice( productsPrice ) }</span>
				</div>
			) }
			<div className="configurator-price-total" role="status" aria-live="polite">
				<span className="configurator-price-total-label">{ __( 'Total', 'at-vehicle-configurator' ) }</span>
				<span className="configurator-price-total-value" aria-label={ __( 'Total price', 'at-vehicle-configurator' ) + ': ' + formatPrice( total ) }>
					{ formatPrice( total ) }
				</span>
			</div>
			{ installationHours > 0 && (
				<p className="configurator-price-installation-note">
					{ __( 'Prices include installation.', 'at-vehicle-configurator' ) }
				</p>
			) }
		</div>
	);
};

export default PriceSummary;
